// @flow
import React from 'react';
import classNames from 'classnames';
import length from 'ramda/es/length';

import LineInput, { LineDateInput } from 'app/common/ui/LineInput';
import Button, { ButtonsBar } from 'app/common/ui/Button';
import { PlainColumns, PlainColumn } from 'app/common/ui/PlainGrid';
import Tooltip from 'app/common/ui/Tooltip';
import type { Fields } from 'app/actions/addChild';
import cardOld from 'app/images/card_old.png';
import cardNew from 'app/images/card_new.png';
import cardIdent1 from 'app/images/card_identificator1.png';
import cardIdent2 from 'app/images/card_identificator2.png';
import cardIdent3 from 'app/images/card_identificator3.png';
import { ACCOUNT_IS_CARDNUM } from 'app/actions/addChild/check';

import enhanceAddChildForm from './enhanceAddChildForm';
import styles from './AddChildForm.scss';


type Props = {
  onClose: (e: SyntheticEvent<HTMLElement>) => void,
  handleChange: (e: SyntheticEvent<HTMLElement>) => void,
  handleChangeDate: (string, string, string) => void,
  handleSubmit: (e: SyntheticEvent<HTMLElement>) => void,
  values: Fields,
  error: string,
  sending: boolean,
  fieldsNames: Fields,
  submitTip: string,
  submitTitle: string,
  step: number,
  disabledDays: (day: number) => boolean,
}

const AddChildForm = ({
  onClose,
  handleChange,
  handleChangeDate,
  handleSubmit,
  values,
  error,
  sending,
  fieldsNames,
  submitTip,
  submitTitle,
  step,
  disabledDays,
}: Props) =>
  <form onSubmit={handleSubmit}>
    <div className={styles.header}>Введите данные ребенка</div>
    <PlainColumns>
      {/* STEP 1 */}
      <PlainColumn div={1}>
        <LineInput
          align="left"
          name="card_number"
          placeholder={fieldsNames.card_number}
          onChange={handleChange}
          value={values.card_number}
          disabled={step > 1 || sending}
          isError={false}
        />
      </PlainColumn>
      {step === 1
        && <div className={styles.examplesContainer}>
          <div className={styles.examplesTitle}>
            Пример места расположения номера на разных видах идентификаторов:
          </div>
          <div className={classNames(styles.examples, styles.row1)}>
            <img src={cardOld} alt="Пример карты" />
            <img src={cardNew} alt="Пример карты" />
          </div>
          <div className={classNames(styles.examples, styles.row2)}>
            <img src={cardIdent1} alt="Пример идентификатора" className={styles.cardIdent1} />
            <img src={cardIdent2} alt="Пример идентификатора" className={styles.cardIdent2} />
            <img src={cardIdent3} alt="Пример идентификатора" className={styles.cardIdent3} />
          </div>
        </div>}
      {/* STEP 2 */}
      {step > 1
        && length(values.card_number) !== ACCOUNT_IS_CARDNUM
        && <PlainColumn div={1}>
          <LineInput
            align="left"
            className={styles.input}
            name="account_number"
            placeholder={fieldsNames.account_number}
            onChange={handleChange}
            value={values.account_number}
            disabled={step > 2 || sending}
            isError={false}
          />
        </PlainColumn>}
      {/* STEP 3 */}
      {step > 2
        && <PlainColumn div={2}>
          <LineInput
            align="left"
            className={styles.input}
            name="first_name"
            placeholder={fieldsNames.first_name}
            onChange={handleChange}
            value={values.first_name}
            disabled={sending}
            isError={false}
          />
        </PlainColumn>}
      {step > 2
        && <PlainColumn div={2}>
          <LineDateInput
            align="left"
            className={styles.input}
            name="birthdate"
            placeholder={fieldsNames.birthdate}
            onChangeDate={handleChangeDate}
            value={values.birthdate}
            disabled={sending}
            disabledDaysInPicker={disabledDays}
          />
        </PlainColumn>}
    </PlainColumns>
    {error && <div className={styles.error}>{error}</div>}
    <ButtonsBar className={styles.buttons} right>
      <Button value="Отмена" onClick={onClose} outline />
      <Tooltip text={submitTip}>
        <Button
          submit
          value={submitTitle}
          disabled={sending || !!submitTip}
        />
      </Tooltip>
    </ButtonsBar>
  </form>;

export default enhanceAddChildForm(AddChildForm);
